import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faBuilding, faFileAlt, faCog, faFileInvoice, faBoxes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Sidebar.css';

const Sidebar = () => {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

  return (
    <nav className="sidebar">
      <NavLink to="/app/dashboard" className={({ isActive }) => isActive ? "active" : ""} title="Dashboard">
        <FontAwesomeIcon icon={faChartLine} />
      </NavLink>
      <NavLink to="/app/accounts" className={({ isActive }) => isActive ? "active" : ""} title="Accounts">
        <FontAwesomeIcon icon={faBuilding} />
      </NavLink>
      <NavLink to="/app/quotes" className={({ isActive }) => isActive ? "active" : ""} title="Quotes">
        <FontAwesomeIcon icon={faFileAlt} />
      </NavLink>
      <NavLink to="/app/bills" className={({ isActive }) => isActive ? "active" : ""} title="Bills">
        <FontAwesomeIcon icon={faFileInvoice} />
      </NavLink>
      <NavLink to="/app/products" className={({ isActive }) => isActive ? "active" : ""} title="Products">
        <FontAwesomeIcon icon={faBoxes} />
      </NavLink>
      {!isDemo && (
        <NavLink to="/app/settings" className={({ isActive }) => isActive ? "active" : ""} title="Settings">
          <FontAwesomeIcon icon={faCog} />
        </NavLink>
      )}
    </nav>
  );
};

export default Sidebar;
